import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from 'react-i18next'

import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from "react-datepicker"

import FilterSearch from 'pages/parts/FilterSearch'
import { httpOk, GET, POST, PUT, FILE_D } from 'helpers/api'
import { returnSign, findKeyFromArrayByValue, formatDate, filterDates, FILTER_DATE } from 'helpers/helpers'
import MaskedInput from "react-text-mask"

function Index() {
	const { t } = useTranslation()
	const date = new Date()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({
		dates: [],
		users: [],
	})
	const [poses, setPoses] = useState([])
	const [userRoles, setUserRoles] = useState([])
	const [employees, setEmployees] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [modalCreate, setModalCreate] = useState(false)
	const [modalUpdate, setModalUpdate] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		activeTab: 'time',
		pos_id: reduxAccount.pos_id,
		status: 1,
		search: '',
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
	})

	async function searchWithFilter(passedData = {}) {
		var filterUrl = "/users-attendances"
		var urlParams = ""
		checkFilter()

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.role)
			urlParams += returnSign(urlParams) + 'role=' + filterData.role
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		if (passedData['excel']) {
			urlParams += returnSign(urlParams) + 'excel=true'

			const responseExcel = await FILE_D(`/users-attendances` + urlParams)
			if (httpOk(responseExcel)) {
				// Создаем объект Blob из полученного файла
				const file = new Blob([responseExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Создаем ссылку для скачивания файла
				const fileUrl = URL.createObjectURL(file);

				// Создаем ссылку для скачивания файла в браузере
				const link = document.createElement('a');
				link.href = fileUrl;
				link.setAttribute('download', `attendances.xlsx`);
				document.body.appendChild(link);
				link.click();

				// Удаляем ссылку после скачивания файла
				URL.revokeObjectURL(fileUrl);
			}
			return
		}

		if (`/users-attendances${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)

		setDropdownIsOpen(false)
	}

	async function createUsersAttendances(e) {
		e.preventDefault();

		const response = await POST('/users-attendances', selectedItem, { loader: true })
		if (httpOk(response)) {
			toggleModalCreate();
			searchWithFilter()
		}
	}

	async function updateUsersAttendances(e) {
		e.preventDefault();

		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy.check_in_time = formatDate(parseCustomDate(selectedItemCopy.check_in_time), "yyyy-MM-dd HH:mm:ss")
		selectedItemCopy.check_out_time = formatDate(parseCustomDate(selectedItemCopy.check_out_time), "yyyy-MM-dd HH:mm:ss")

		const response = await PUT('/users-attendances', selectedItemCopy, { loader: true })
		if (httpOk(response)) {
			toggleModalUpdate()
			searchWithFilter()
		}
	}

	function parseCustomDate(dateStr) {
		const [datePart, timePart] = dateStr.split(' ');
		if (!datePart || !timePart) return null;

		const [day, month, year] = datePart.split('.').map(Number);
		const [hours, minutes] = timePart.split(':').map(Number);

		return new Date(year, month - 1, day, hours, minutes);
	}

	function isValidDate(date) {
		return date instanceof Date && !isNaN(date);
	}

	async function handleChange(e) {
		var selectedItemCopy = { ...selectedItem }
		if (e.target.name === "minutes" && Number(e.target.value) > 59) {
			return;
		}
		selectedItemCopy[e.target.name] = e.target.value;
		if (e.target.name === "hours" || e.target.name === "minutes") {
			let newCheckOutDate = parseCustomDate(selectedItemCopy.check_in_time);

			newCheckOutDate.setHours(newCheckOutDate.getHours() + Number(selectedItemCopy["hours"]));
			newCheckOutDate.setMinutes(newCheckOutDate.getMinutes() + Number(selectedItemCopy["minutes"]));

			selectedItemCopy.check_out_time = formatDate(newCheckOutDate, "dd.MM.yyyy HH:mm")
		}

		if (e.target.name === "check_in_time" || e.target.name === "check_out_time") {
			const parsedCheckIn = parseCustomDate(selectedItemCopy.check_in_time);
			const parsedCheckOut = parseCustomDate(selectedItemCopy.check_out_time);

			if (isValidDate(parsedCheckIn) && isValidDate(parsedCheckOut)) {
				selectedItemCopy.check_in_time = parsedCheckIn;
				selectedItemCopy.check_out_time = parsedCheckOut;

				selectedItemCopy = getItemTimeDifference(selectedItemCopy);

				selectedItemCopy.check_in_time = formatDate(selectedItemCopy.check_in_time, "dd.MM.yyyy HH:mm");
				selectedItemCopy.check_out_time = formatDate(selectedItemCopy.check_out_time, "dd.MM.yyyy HH:mm");
			}
		}
		setSelectedItem(selectedItemCopy)
	}


	function handleClickItem(item = {}) {
		const user = data.users.find(user => user.employee_id === item.employee_id);
		if (!user) return false;
		const entries = user.dates[item.date]['shifts'] ?? [];

		if (!entries.length) {
			var sendData = {
				'employee_id': item.employee_id,
				'check_in_time': item.date,
				'check_out_time': item.date,
			}

			toggleModalCreate(true, sendData)
		}
	}

	function resetFilter() {
		setFilterData({
			pos_id: reduxAccount.pos_id,
			status: null,
			role: null,
			search: '',
		})
		setFilterDataExist(false)
		searchWithFilter()
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.status === null &&
			filterData.role === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handleSelectFastDate(option) {
		var obj = filterDates(option.id)
		setFilterData({
			...filterData,
			'start_date': obj.start_date,
			'end_date': obj.end_date,
			'fast_date_id': option.id,
		})
	}

	function getItemTimeDifference(item) {
		const checkIn = new Date(item.check_in_time);
		const checkOut = new Date(item.check_out_time);

		const diffMs = checkOut - checkIn; // разница в миллисекундах
		const diffMins = Math.floor(diffMs / 1000 / 60); // в минутах
		const hours = Math.floor(diffMins / 60);
		item.minutes = String(diffMins % 60).padStart(2, '0');
		item.hours = hours;

		return item;
	}

	function toggleModalUpdate(bool = false, item = {}) {
		if (bool) {
			item = { ...item }
			item = getItemTimeDifference(item)
			item.check_in_time = formatDate(item.check_in_time, "dd.MM.yyyy HH:mm")
			item.check_out_time = formatDate(item.check_out_time, "dd.MM.yyyy HH:mm")
			item.check_in_time_copy = item.check_in_time
			item.check_out_time_copy = item.check_out_time
		}

		setSelectedItem(item)
		setModalUpdate(bool)
	}

	function toggleModalCreate(bool = false, item = {}) {
		setModalCreate(bool)
		setSelectedItem(item)
	}

	async function getPoses() {
		const response = await GET('/helper/poses-head')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getUserRoles() {
		const response = await GET('/helper/user-roles')
		if (httpOk(response)) setUserRoles(response.data)
	}

	async function getEmployees() {
		const response = await GET('/helper/employees')
		if (httpOk(response)) setEmployees(response.data)
	}

	useEffect(() => {
		getPoses()
		getUserRoles()
		getEmployees()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('attendances')} [{data.users?.length}]
				</h4>
				<div className="d-flex gap-2">
					<button className="btn btn-primary"
						onClick={() => toggleModalCreate(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('role')}</label>
												<Select
													options={userRoles}
													value={userRoles.find(option => option.role === filterData.role) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'role': option.role })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.role}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('date')}</label>
												<Select
													options={FILTER_DATE}
													value={FILTER_DATE.find(option => option.id === filterData.fast_date_id) || ''}
													onChange={(option) => handleSelectFastDate(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div className="d-flex gap-2">
								<button className="btn btn-outline-primary btn-wide-2"
									title="EXCEL"
									onClick={() => searchWithFilter({ 'excel': true })}>
									<i className="uil uil-file-download-alt"></i>
								</button>

								<button className={`btn btn-wide-2 ${filterData.activeTab === 'time' ? 'btn-primary' : 'btn-outline-primary'}`}
									onClick={() => setFilterData({ ...filterData, 'activeTab': 'time' })}>
									{t('time')}
								</button>
								<button className={`btn btn-wide-2 ${filterData.activeTab === 'shift' ? 'btn-primary' : 'btn-outline-primary'}`}
									onClick={() => setFilterData({ ...filterData, 'activeTab': 'shift' })}>
									{t('shifts')}
								</button>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<b> - </b>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.role &&
									<span className="me-2">
										<b>{t('role')}: </b>
										{findKeyFromArrayByValue(userRoles, 'role', filterData.role, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive table-attendances">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '150px' }}>{t('FIO')}</th>
									<th style={{ 'minWidth': '150px' }}>{t('role')}</th>
									{data?.dates?.map((item, index) => (
										<th style={{ 'minWidth': '130px' }} className="text-center" key={index}>
											{formatDate(item, "dd.MM.yyyy")}
										</th>
									))}
									<th style={{ 'minWidth': '150px' }} className="text-end">{t('total')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.users?.map((employee, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis" title={employee.name}>{employee.name}</td>
										<td className="td-ellipsis" title={employee.role_name}>{employee.role_name}</td>

										{Object.entries(employee?.dates).map(([date, dateKey], index) => (
											<td key={index} className={!dateKey?.shifts?.length ? 'td-hover' : ''}
												onClick={() => {
													if (!dateKey?.shifts?.length) {
														handleClickItem({
															'employee_id': employee.employee_id,
															'date': date,
														})
													}
												}}>
												{filterData.activeTab === 'shift' &&
													<>
														{dateKey.shifts.length > 0 ? (
															dateKey.shifts.map((item, index2) => (
																<div key={index2} className="text-center td-hover"
																	onClick={() => toggleModalUpdate(true, item)}>
																	{formatDate(item.check_in_time, "HH:mm")} - {formatDate(item.check_out_time, "HH:mm")}
																</div>
															))
														) : (
															<div></div>
														)}
													</>
												}
												{filterData.activeTab === 'time' &&
													<div className="text-center">
														{dateKey.total_duration_formatted}
													</div>
												}
											</td>
										))}

										<td className="text-end">
											<b>{employee.total_duration_formatted}</b>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL UPDATE */}
			<Modal show={modalUpdate} animation={false} centered
				backdrop="static" onHide={() => toggleModalUpdate()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('edit')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => updateUsersAttendances(e)} autoComplete="off">
						<div className="d-flex gap-2">
							<div className="w-100">
								<div>
									<label>{t('check_in_time')}</label>
									<MaskedInput
										name="check_in_time"
										mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
										className="form-control"
										guide={true}
										onChange={handleChange}
										value={selectedItem?.check_in_time ?? ""}
									/>
								</div>
								<div>
									<label>{t('check_out_time')}</label>
									<MaskedInput
										name="check_out_time"
										mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
										className="form-control"
										guide={true}
										onChange={handleChange}
										value={selectedItem?.check_out_time ?? ""}
									/>
								</div>

								<div className="d-flex align-items-center justify-content-between gap-2 mt-2">
									<label>{t('check_in_time')}</label>

									<div className="d-flex align-items-center justify-content-end gap-2">
										<input
											name="hours"
											type="text"
											className="form-control text-end"
											style={{ width: '50px', height: '30px' }}
											onChange={handleChange}
											value={selectedItem?.hours ? selectedItem?.hours : 0}
										/>
										:
										<input
											name="minutes"
											type="text"
											className="form-control text-end"
											style={{ width: '50px', height: '30px' }}
											onChange={handleChange}
											value={selectedItem?.minutes ? selectedItem?.minutes : "00"}
										/>
									</div>
								</div>
							</div>

							<div className="w-100">
								<div>
									<label>{t('check_in_time')}</label>
									<MaskedInput
										mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
										className="form-control"
										guide={true}
										value={selectedItem?.check_in_time_copy ?? ""}
										disabled
									/>
								</div>
								<div>
									<label>{t('check_out_time')}</label>
									<MaskedInput
										mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
										className="form-control"
										guide={true}
										value={selectedItem?.check_out_time_copy ?? ""}
										disabled
									/>
								</div>

							</div>
						</div>

						<div>
							<label>{t('note')}</label>
							<textarea
								className="form-control"
								guide={true}
								onChange={(e) => setSelectedItem({ ...selectedItem, note: e.target.value })}
								value={selectedItem?.note ?? ""}
							/>
						</div>

						<div className="d-flex mt-2">
							<div className="form-check">
								<input className="form-check-input" type="checkbox" id="status"
									onChange={(e) => setSelectedItem({ ...selectedItem, 'status': e.target.checked })} />
								<label class="form-check-label" for="status">
									{t('delete')}
								</label>
							</div>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalUpdate()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL UPDATE */}

			{/* MODAL CREATE */}
			<Modal show={modalCreate} animation={false} centered
				backdrop="static" onHide={() => toggleModalCreate()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('edit')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUsersAttendances(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('employee')}<span className="required-mark">*</span></label>
							<Select
								options={employees}
								value={employees.find(option => option.id && option.id === selectedItem.employee_id) || null}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'employee_id': option ? option.id : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group w-100">
							<label>{t('check_in_time')}</label>
							<div className="calendar-input">
								<DatePicker
									className="form-control"
									showTimeSelect
									timeFormat="HH:mm"
									timeIntervals={30} // шаг времени в минутах
									dateFormat="dd.MM.yyyy HH:mm"
									selected={selectedItem.check_in_time ? new Date(selectedItem.check_in_time) : ''}
									onChange={(date) => setSelectedItem({
										...selectedItem,
										check_in_time: formatDate(date, 'yyyy-MM-dd HH:mm:ss') // или другой нужный формат
									})} />
								<i className="uil uil-calendar-alt"></i>
							</div>
						</div>
						<div className="form-group w-100">
							<label>{t('check_in_time')}</label>
							<div className="calendar-input">
								<DatePicker
									className="form-control"
									showTimeSelect
									timeFormat="HH:mm"
									timeIntervals={30} // шаг времени в минутах
									dateFormat="dd.MM.yyyy HH:mm"
									selected={selectedItem.check_out_time ? new Date(selectedItem.check_out_time) : ''}
									onChange={(date) => setSelectedItem({
										...selectedItem,
										check_out_time: formatDate(date, 'yyyy-MM-dd HH:mm:ss') // или другой нужный формат
									})} />
								<i className="uil uil-calendar-alt"></i>
							</div>
						</div>

						<div>
							<label>{t('note')}</label>
							<textarea
								className="form-control"
								guide={true}
								onChange={(e) => setSelectedItem({ ...selectedItem, note: e.target.value })}
								value={selectedItem?.note ?? ""}
							/>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalCreate()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE */}

		</>
	)
}

export default Index